<template>
  <div id="app">
    <!-- <Showy/> -->
    <!-- 首部 start -->
    <header style="position:relative;">
      <div class="h_head">
        <div class="h_type">
          <div :class="isMobile2?'h_type_logo2':'h_type_logo'">
            <div style="width:539px">
              <img src="./assets/icon1.png" class="icon1"/>
              <label class="zh_company">惠州市天宇信息技术有限公司</label>
              <label class="en_commpany">HUIZHOU TIANYU INFORMATION TECHNOLOGY CO.，LTD.</label>
            </div>
          </div>
        </div>
        <div :class="isMobile2?'h_nav2':'h_nav'">
          <div :class="isMobile2?'h_nav_body2':'h_nav_body'">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item @click="test(0)" style="height:55px; color:#fff; width:calc(100% / 3); text-align:center;font-size: 16px;">首页</el-menu-item>

              <el-submenu style="width:calc(100% / 3);" v-for='(tabItem,index) in navlist' :key="index" :index="index + ''">
                <template slot="title" >
                  <div @click="test(index + Number(1))">{{tabItem.name}}</div>
                </template>
                <!-- <el-menu-item index="1-2">{{tabItem.children.name}}</el-menu-item> -->
                <!-- <el-menu-item index="1-3">{{tabItem.children.name}}</el-menu-item> -->
              </el-submenu>
            </el-menu>
          </div>

        </div>
      </div>
    </header>
    
    <!-- 首部 end -->
    <router-view/>


    <footer :class="isMobile?'footer2':'footer'">
      <p style="width:100%;display:flex;justify-content: center;margin-top:20px;">
        <span>惠州市天宇信息技术有限公司</span>
        <span style="margin: 0 2%;">联系电话：0752-2559023</span>
        <span>地址：惠州市河南岸21号小区德明国际公寓2单元26层02号房</span>
      </p>
      <div style="display:flex;align-items: center;justify-content: center;margin-top: 10px;padding-bottom: 10px;">
        <div style="display:flex;align-items: center;margin-right: 15px;">
          <img src="@/assets/gov.png" alt="" style="width: 20px;height:20px;margin-right: 5px;cursor: pointer;" @click="urlGo2">
          <a href="#" rel="noreferrer" target="_blank" @click="urlGo2" style="color: #fff;text-decoration: none;">粤公网安备44130202001244</a>
          </div>
        <a href="#" rel="noreferrer" target="_blank" @click="urlGo" style="color: #fff;text-decoration: none;">粤ICP备19098822号-1</a>
      </div>
      <!-- <a href="https://beian.miit.gov.cn" target="_blank" style="margin-top: 10px;padding-bottom: 10px;cursor: pointer;color: #fff;text-decoration: none;">
        粤ICP备19098822号-1
      </a> -->
      <!-- <p style="background-color: #959595;margin-top: 10px;padding-bottom: 10px;cursor: pointer;" @click="urlGo">
        粤ICP备19098822号-1
      </p> -->
    </footer>
  </div>
</template>
<script>
// import Showy from '@/views/components/showy.vue'
import bus from '@/utils/bus'
export default {
  data() {
    return {
      achange: 1,
      statuNum: 0,
      inputdata: "",
      navlist:[
        {name:'公司介绍'},
        {name:'企业文化'}
      ],

      childList:[],
      nowIndex: 0,
      dropdownActive: false,
      activeIndex: '1',
      isMobile2:false,
    };
  },
  created(){
    this.inputdata = ""
    this.getScreen2()
  },
  components:{
    // Showy
  },
  methods: {
    urlGo(){
      window.open(`https://beian.miit.gov.cn`,"_block");
    },
    urlGo2(){
      window.open(`https://beian.mps.gov.cn/`,"_block");
    },
    getScreen2() {
      if (
        navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      ) {
        this.isMobile2 = true;
        // console.log("手机");
      } else {
        this.isMobile2 = false;
        // console.log("pc");
      }
    },
    search() {
      bus.$emit('testA')
      if(this.$route.name != "Search"){
        this.$router.push({ path: "/Search"});
        window.sessionStorage.setItem("search", this.inputdata);
      }else{
        window.sessionStorage.setItem("search", this.inputdata);
      }
    },
    test(num) {
      // console.log(num,'num');
      // console.log(num)
      if (num == 0 && this.$route.name != "Home") {
        this.$router.push({ path: "/home" });
      }
      // 行协概括
      if (num == 1 && this.$route.name != "IndustryProfile") {
        this.$router.push({ path: "/IndustryProfile" ,query:{num:0}});
      }
      // 行协动态
      if (num == 2 && this.$route.name != "IndustryTrends") {
        this.$router.push({ path: "/Industrytrends" ,query:{num:0}});
      }
    },
    handleSelect(key,keyPath){
      // console.log(key,'key');
      // debugger

      if (this.$route.name != "IndustryProfile" && key.split('-')[0] == 0) {
        this.$router.push({path:"/IndustryProfile",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "IndustryProfile" && key.split('-')[0] == 0){
        ptext(key.split('-')[1])
      }

      if (this.$route.name != "IndustryTrends" && key.split('-')[0] == 1) {
        this.$router.push({path:"/IndustryTrends",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "IndustryTrends" && key.split('-')[0] == 1){
        ptext(key.split('-')[1])
      }

      if (this.$route.name != "MemberCenter" && key.split('-')[0] == 2) {
        this.$router.push({path:"/MemberCenter",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "MemberCenter" && key.split('-')[0] == 2 && key.split('-')[1] == 3){
        ptext(key.split('-')[1])
        // console.log(key.split('-')[1],'111111111111111111111');
      }else if(this.$route.name == "MemberCenter" && key.split('-')[0] == 2) {
        ptext(key.split('-')[1])
      }

      if (this.$route.name != "IndustryInformation" && key.split('-')[0] == 3) {
        this.$router.push({path:"/IndustryInformation",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "IndustryInformation" && key.split('-')[0] == 3){
        ptext(key.split('-')[1])
      }

      if (this.$route.name != "TalentRecruitment" && key.split('-')[0] == 4) {
        this.$router.push({path:"/TalentRecruitment",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "TalentRecruitment" && key.split('-')[0] == 4){
        ptext(key.split('-')[1])
      }

      if (this.$route.name != "DownloadCenter" && key.split('-')[0] == 5) {
        this.$router.push({path:"/DownloadCenter",query:{num:key.split('-')[1]}})
      }else if(this.$route.name == "DownloadCenter" && key.split('-')[0] == 5){
        ptext(key.split('-')[1])
      }
      
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.name == "Home") {
        this.statuNum = 0;
      }
      if (this.$route.name == "IndustryProfile") {
        this.statuNum = 1;
      }
      if (this.$route.name == "IndustryTrends") {
        this.statuNum = 2;
      }
      if (this.$route.name == "MemberCenter") {
        this.statuNum = 3;
      }
      if (this.$route.name == "IndustryInformation") {
        this.statuNum = 4;
      }
      if (this.$route.name == "DownloadCenter") {
        this.statuNum = 6;
      }
      if (this.$route.name == "TalentRecruitment") {
        this.statuNum = 5;
      }
      if (this.$route.name == "Search") {
        this.statuNum = 0;
      }
    },
    inputdata(){
      window.sessionStorage.setItem("search", this.inputdata);
    }
  },
  mounted() {
    // if(window.sessionStorage.getItem("search")){
    //   this.inputdata = window.sessionStorage.getItem("search");
    // }


    if (this.$route.name == "Home") {
      this.statuNum = 0;
    }
    if (this.$route.name == "IndustryProfile") {
      this.statuNum = 1;
    }
    if (this.$route.name == "IndustryTrends") {
      this.statuNum = 2;
    }
    if (this.$route.name == "MemberCenter") {
      this.statuNum = 3;
    }
    if (this.$route.name == "IndustryInformation") {
      this.statuNum = 4;
    }
    if (this.$route.name == "DownloadCenter") {
      this.statuNum = 6;
    }
    if (this.$route.name == "TalentRecruitment") {
      this.statuNum = 5;
    }
    if (this.$route.name == "ContentDetails") {
      if (this.$route.query.pos1 == "行协动态") {
        this.statuNum = 2;
      }
      if (this.$route.query.pos1 == "会员中心") {
        this.statuNum = 3;
      }
    }

    
  }
};
</script>
<style lang="less">
.el-menu-demo {
  display:flex;
}

// html{
//      /* 网页全部设置灰色 */
//      -webkit-filter: grayscale(100%);
// 	 filter: grayscale(100%);
// }
/* 首部 start*/

/* 公司标题 start*/
.h_head {
  width: 100%;
  height: 190px;
  display: flex;
  flex-direction: column;
}

.h_type {
  height: 100px;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  justify-content: center;
  // width: 66%;
  // margin: 0px 20% 40px;
  // min-width: 800px;
  white-space: nowrap;
  .h_type_logo {
    display: flex;
    width:1300px;
    justify-content: center;
    // margin-left: 50%;
    // transform: translateX(-50%);
  }
  .h_type_logo2 {
    display: flex;
    width:1300px;
    margin-left: inherit;
    // transform: translateX(-50%);
  }
}

.h_type > div:nth-last-child(2) {
  width: 60%;
  // margin-left: 28px;
}

.icon1 {
  height: 82px;
    width: 81px;
    margin-top: 25px;
}

.zh_company {
  color: rgb(49, 104, 155);
  font-size: 32px;
  font-weight: 1000;
  position: relative;
  top: -35px;
  left: 20px;
}

.en_commpany {
  color: rgb(156, 167, 179);
  font-size: 14px;
  position: relative;
  left: -375px;
  top: -10px;
  white-space: nowrap;
}
/* 公司标题 end*/

/* 搜索 start*/
.h_checttext {
  padding: 5px;
  padding-top: 50px;
  padding-left: 285px;
  display: flex;
  flex-direction: row;
  #check{
    outline: none
  }
}
.h_checttext2 {
  padding: 5px;
  padding-top: 50px;
  padding-left: 35px;
  display: flex;
  flex-direction: row;
  #check{
    outline: none
  }
}

.h_check {
  background-color: #31689b;
  color: white;
  display: inline-block;
  width: 64px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  border-radius: 0 5px 5px 0;
  // margin-left:20px;
}
.h_check:active {
  background-color: rgb(21, 71, 119);
  font-weight: 1000;
}
/* 搜索 end*/
/* 导航 start*/
.h_nav2 {
  width: 100%;
  height: 55px;
  .h_nav_body2 {
    width:1023px;
    margin-left: inherit;
    
    // transform: translateX(-50%);
    .el-menu.el-menu--horizontal {
    width: 100%;
    height: 55px;
    background-color: #31689b;
    // margin-left:50% - 24px;
    // margin-left: 50%;
    // transform: translateX(-25%);
    // transform:translateX(-50%);
    color: #fff;
    .el-submenu__title {
      font-size: 16px;
      color: #fff;
      height: 55px !important;
      &:hover {
        background-color: rgb(21, 71, 119);
        color: #fff;
      }
    }
  }
  }
}
.h_nav {
  width: 100%;
  height: 55px;
  background-color: #31689b;
  // box-shadow: 0px 2px 8px #888888;
  .h_nav_body {
    width:1040px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .el-submenu {
    width: 133px;
  }
  .is-opened {
    height:55px;
  }
  .el-menu.el-menu--horizontal {
    width: 100%;
    height: 55px;
    background-color: #31689b;
    // margin-left:50% - 24px;
    // margin-left: 50%;
    // transform: translateX(-25%);
    // transform:translateX(-50%);
    color: #fff;
    .el-submenu__title {
      font-size: 16px;
      color: #fff;
      height: 55px !important;
      &:hover {
        background-color: rgb(21, 71, 119);
        color: #fff;
      }
    }
  }
  
}
.el-icon-arrow-down:before {
  content: " " !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
  display:none!important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  text-align:center;
  border:0 !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border:0px !important;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #154777  !important;
}
.el-menu-item:focus, .el-menu-item:hover {
  background-color: #154777  !important;
}

.el-menu--horizontal .el-menu .el-menu-item, 
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #31689b !important;
  color: #fff !important;
  text-align: center;
  &:hover {
    background-color: #154777  !important;
  }
}

.el-menu--popup-bottom-start {
  margin-top:0px !important;
}
.el-menu--popup {
  padding:0 !important;
}
.el-menu.el-menu--horizontal {
  border:0px !important;
}
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
  min-width: 133px !important;
}

.h_nav > nav {
  width: 100%;
  margin: 0px 19%;
  display: flex;
  flex-direction: row;
}
.wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .wrapper>div {
        flex: 1;
        text-align: center;
        height: 36px;
        line-height: 36px;
    }
    .dropdownWrapper {
        /*margin-top: 36px;*/
        border: 1px solid #2C3E50;
        font-size: 14px;
    }
    .dropdownWrapper li {
        display: block;
    }

    .nav-item.active {
        background: #e3e3d3;
    }
    .dropdownBtn {
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    .nav-item {
        cursor: pointer;
    }
.h_nav > nav > a,
.aNav {
  color: white;
  width: 170px;
  min-width: 100px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  font-family: Roboto;
}
.aNav:hover{
  cursor: pointer;
  background-color: rgb(21, 71, 119);
}
.a_change {
  background-color: rgb(21, 71, 119);
  font-weight: 1000;
}
.a_normal {
  color: white;
  max-width: 179px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  font-size: 18px;
}
.h_nav > nav > a:active {
  background-color: rgb(21, 71, 119);
  font-weight: 1000;
}

.h_nav > nav > a:hover {
  cursor: pointer;
  background-color: rgb(21, 71, 119);
}

.h_check:hover {
  cursor: pointer;
}
/* 导航 end*/
/* 首部 end*/

/* 尾部 start*/
.footer {
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  width: 100%;
  // height: 15px;
  float: left;
  // margin: 0px 21%;
  margin-left: 50%;
  transform: translateX(-50%);
  // margin-left: 494px;
  margin-top: 21px;
  background-color: #959595;
  // border-top: 1px solid rgba(199, 199, 199, 1);
  padding-bottom: 1;
}
.footer2 {
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  width: 100%;
  // height: 15px;
  float: left;
  // margin: 0px 21%;
  margin-left: inherit;
  // transform: translateX(-50%);
  // margin-left: 494px;
  margin-top: 21px;
  background-color: #959595;
  // border-top: 1px solid rgba(199, 199, 199, 1);
  padding-bottom: 10px;
}
/* 尾部 end*/
</style>